/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SHOW_MISSING_IMPORT,
  HIDE_MISSING_IMPORT,
} from '../actions/actionTypes';

const initialState = {
  showMissingImport: true,
}

export default function (state = initialState, action) {
  switch (action.type) {
      case SHOW_MISSING_IMPORT:
          return {
            showMissingImport:true
          }
      case HIDE_MISSING_IMPORT:
        return {
          showMissingImport:false
        }
      default:
          return state;
  }
}
